<template>
  <div class="in-lesson-config-section-info">
    <div class="title-content">
      <span class="title">{{ title }}</span>
      <a-button @click="preivew" type="link" :disabled="!list.length" class="preview-btn">
        预览
      </a-button>
      <span class="tip">
        <a-icon class="tip-icon" type="exclamation-circle" />
        {{ tip }}
      </span>
    </div>
    <div>
      <div v-if="list.length > 0">
        <span
          class="item-btn"
          v-for="item in list"
          :key="item.id"
          @click="play(item)"
        >
          <!-- <span class="tag" v-if="item.noStudy">选学</span> -->
          <a-tooltip v-if="item.name.length > 5" placement="top">
            <template slot="title">
              <span style="display: inline-block;max-width: 210px;">{{ item.name }}</span>
            </template>
            <span class="item" :class=" (currentPlay.type === PLAY_TYPE.PREVIEW && currentPlay.courseType === type && currentPlay.index === item.index) ? 'active': ''">{{ item.name }}</span>
          </a-tooltip>
          <span v-else class="item" :class=" (currentPlay.type === PLAY_TYPE.PREVIEW && currentPlay.courseType === type && currentPlay.index === item.index) ? 'active': ''">{{ item.name }}</span>
        </span>
      </div>
      <div v-else class="empty">
        <span>暂无数据</span>
      </div>
    </div>
  </div>
</template>
<script>

import { PLAY_TYPE } from '../../constants'

export default {
  props: {
    title: {
      type: String,
      default: () => ''
    },
    tip: {
      type: String,
      default: () => ''
    },
    list: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: () => ''
    },
    currentPlay: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      PLAY_TYPE
    }
  },
  methods: {
    play(record) {
      this.$emit('play', record, PLAY_TYPE.PREVIEW, this.type)
    },
    preivew() {
      this.$emit('preview', this.type, PLAY_TYPE.PREVIEWLIST)
    }
  }
}
</script>
<style scoped lang="less">
  .in-lesson-config-section-info {
    // margin-bottom: 12px;

    .title-content {
      font-size: 0;
      display: flex;
      align-items: center;
      margin-bottom: 4px;
    }
    .title {
    font-weight: 700;
    font-size: 14px;
    line-height: 22px;
    color: #505873;
    }

    .preview-btn {
      padding: 0;
      margin-left: 8px;
      margin-right: 24px;
      position: relative;
      top: 1px;
      &:hover,
      &:active,
      &:focus {
        background-color: #fff !important;
        border-color: #fff !important;
      }
    }

    .tip {
      font-size: 12px;
      line-height: 22px;
      color: #98A2B2;
    }
    .item-btn {
      display: inline-block;
      margin-right: 8px;
      margin-bottom: 4px;
      height: 39px;
      position: relative;
      overflow: hidden;
      .tag {
        display: block;
        position: absolute;
        background: #FFF8E5;
        border-radius: 0px 0px 4px 4px;
        width: 53px;
        text-align: center;
        height: 18px;
        font-family: 'Microsoft YaHei UI';
        font-weight: 400;
        font-size: 12px;
        letter-spacing: 0.04em;
        color: #FF8800;
        transform: rotate(-45deg) scale(.83);
        top: 0;
        left: -17px;
      }
    }
    .item {
      display: inline-block;
      margin: 0;
      box-sizing: border-box;
      padding: 8px 12px;
      background: #F5F7F9;
      border-radius: 8px;
      border: 1px solid #F5F7F9;
      cursor: pointer;
      max-width: 120px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 109px;

      &.active {
        border: 1px solid #3262FD;
      }
    }
    .empty {
      text-align: center;
      padding: 9px 0;
      > span {
        font-size: 14px;
        line-height: 22px;
        color: #505873;
      }
    }
  }
</style>